import clsx from "clsx";

import * as threeUpStyles from "@ui/components/patterns/ThreeUpPattern/ThreeUpPattern.css";
import { ProminentContentCardConfig } from "@ui/context/component-config-context";

const threeUpPattern = {
  lowerMetaSecondComponent: null,
  lowerMetaThirdComponent: null,
  showDek: true,
};

const prominentContentCardConfig: ProminentContentCardConfig = {
  contentBlockSize: "large",
  contentBlockVariation: "standard",
  coverLink: true,
  imageAspectRatio: "wide",
  imageTreatment: null,
  imageOverlay: null,
  imageSquareSizes: "250px",
  lowerMetaFirstComponent: "ContentBlockByline",
  lowerMetaSecondComponent: "Timestamp",
  lowerMetaThirdComponent: "CommentCount",
  mediaVariationIconPlacement: "thumbnail",
  showBorder: false,
  showDek: false,
  showScore: false,
  upperMetaSecondComponent: null,
  upperMetaThirdComponent: null,
  logo: false,
  imagePosition: "imageAbove",
  overlap: false,
  overlapStyle: "default",
  imageLeftTablet: false,
  componentContext: {
    nGridPatternMobile: {
      imageAspectRatio: "wide",
      contentBlockSize: "micro",
      upperMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
    },
    river: {
      imageLeftTablet: true,
      imageAspectRatio: "squareLarge",
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      showBorder: true,
      showDek: true,
      upperMetaSecondComponent: "Timestamp",
    },
    twoUpPatternFirst: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "large",
      contentBlockVariation: "standard",
      imageAspectRatio: "wide",
      showDek: true,
    },
    twoUpPatternSecond: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "large",
      contentBlockVariation: "standard",
      imageAspectRatio: "wide",
      showDek: true,
    },
    threeGridBigPattern: {
      lowerMetaSecondComponent: "CommentCount",
      lowerMetaThirdComponent: null,
      contentBlockSize: "large",
      contentBlockVariation: "special",
    },
    threeUpPatternLargeFirst: {
      ...threeUpPattern,
      imageAspectRatio: "square",
      extraImageStyles: threeUpStyles.imageBg,
    },
    threeUpPatternLargeSecond: {
      ...threeUpPattern,
      imageAspectRatio: "square",
      extraImageStyles: clsx(
        threeUpStyles.secondaryCardMarginTop,
        threeUpStyles.imageBg,
      ),
    },
    threeUpPatternLargeThird: {
      ...threeUpPattern,
      imageAspectRatio: "square",
      extraImageStyles: clsx(
        threeUpStyles.secondaryCardMarginTop,
        threeUpStyles.imageBg,
      ),
    },
    threeUpPatternFirst: {
      ...threeUpPattern,
      extraImageStyles: clsx(
        threeUpStyles.secondaryCardMarginTop,
        threeUpStyles.imageBg,
      ),
    },
    threeUpPatternSecond: {
      ...threeUpPattern,
    },
    threeUpPatternThird: {
      ...threeUpPattern,
    },
    threeUpCategoryPillarLargeFirst: {
      ...threeUpPattern,
    },
    threeUpCategoryPillarLargeSecond: {
      ...threeUpPattern,
    },
    threeUpCategoryPillarLargeThird: {
      ...threeUpPattern,
    },
    threeUpBigPattern: {
      lowerMetaSecondComponent: "CommentCount",
      lowerMetaThirdComponent: null,
    },
    threeUpAltPatternLargeFirst: {
      ...threeUpPattern,
      overlap: true,
      overlapStyle: "default",
      mediaIconInset: "medium",
    },
    threeUpAltPatternLarge: {
      ...threeUpPattern,
      imageAspectRatio: "square",
      mediaIconInset: "medium",
    },
    threeUpAltPatternSmall: {
      ...threeUpPattern,
      overlap: true,
      overlapStyle: "default",
    },
    threeGridPattern: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      upperMetaFirstComponent: null,
    },
    threeGridArticleCategoryRecirc: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      upperMetaFirstComponent: null,
    },
    fourUpPattern: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "jumbo",
      showDek: true,
    },
    fourUpPatternDesktop: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "jumbo",
      showDek: true,
    },
    fourUpAltPattern: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "jumbo",
      contentBlockVariation: "standard",
      showDek: true,
      imageLeftTablet: true,
    },
    fourUpAltPrimaryRightPattern: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "jumbo",
      contentBlockVariation: "standard",
      showDek: true,
    },
    sixUpPatternPrimarySquare: {
      contentBlockSize: "jumbo",
      lowerMetaSecondComponent: null,
      imageAspectRatio: "square",
      lowerMetaThirdComponent: null,
      overlap: false,
      showDek: true,
    },
    sixUpPatternPrimaryWide: {
      contentBlockSize: "jumbo",
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      overlap: true,
      overlapStyle: "default",
      showDek: true,
    },
    eightUpPatternPrimary: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "jumbo",
      imageAspectRatio: "square",
      showDek: true,
    },
    sevenUpPattern: {
      contentBlockVariation: "standard",
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      imagePosition: "imageAbove",
      contentBlockSize: "jumbo",
      imageAspectRatio: "square",
      showDek: true,
    },
    sevenUpPatternDesktop: {
      contentBlockVariation: "standard",
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      imagePosition: "imageAbove",
      contentBlockSize: "jumbo",
      imageAspectRatio: "wide",
      showDek: true,
    },
    sevenUpPatternSecondary: {
      contentBlockVariation: "standard",
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      imagePosition: "imageAbove",
      contentBlockSize: "medium",
      imageAspectRatio: "square",
      showDek: false,
    },
    sevenUpPatternSecondaryDesktop: {
      contentBlockVariation: "standard",
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      imagePosition: "imageAbove",
      contentBlockSize: "medium",
      imageAspectRatio: "square",
      showDek: false,
    },
    eightUpPatternPrimaryDesktop: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "jumbo",
      showDek: true,
    },
    eightUpPatternSecondary: {
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      contentBlockSize: "medium",
      imageAspectRatio: "square",
    },
    imageAndListPattern: {
      imageAspectRatio: "wide",
      imageOverlay: null,
      imageTreatment: "three",
    },
    featuredImageLeadGridMobile: {
      contentBlockSize: "medium",
      lowerMetaSecondComponent: null,
    },
    featuredImageLeadGridDesktop: {
      contentBlockSize: "medium",
      lowerMetaSecondComponent: null,
    },
    fiveGridOverflowPattern: {
      imageAspectRatio: "wide",
      contentBlockSize: "small",
      upperMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
    },
    mapSection: {
      contentBlockSize: "small",
      contentBlockVariation: "standard",
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: false,
      imageAspectRatio: "square",
    },
    threeUpAltTwoPattern: {
      imagePosition: "imageAbove",
      overlap: true,
      overlapStyle: "default",
      imageAspectRatio: "wide",
      contentBlockVariation: "special",
      contentBlockSize: "jumbo",
    },
    threeUpAltTwoPatternSecondaryTablet: {
      imagePosition: "imageAbove",
      overlap: true,
      overlapStyle: "default",
      imageAspectRatio: "wide",
      contentBlockVariation: "special",
      contentBlockSize: "large",
    },
  },
};

export default prominentContentCardConfig;
